import { ResidentialRentComp } from 'types/underwriting/income-approach';
import { CompplexResidentialLeaseOutput } from './types';
import { divide, isNil } from 'lodash';

export const mapCompPlexResidentialLeaseToRentComp = (
  residentialRentComp: CompplexResidentialLeaseOutput
): ResidentialRentComp => {
  const {
    id,
    version,
    isLatestVersion,
    address,
    leaseInformation,
    propertyInformation,
    leaseDate,
    unitNumber,
    numberOfBedrooms,
    status,
  } = residentialRentComp;
  const { state, postalCode, coords } = address;
  const { monthlyRent, unitSquareFootage } = leaseInformation;
  const monthlyRentPerSF = !isNil(unitSquareFootage) ? divide(monthlyRent, unitSquareFootage || 0) : undefined;
  const annualRent = monthlyRent * 12;
  const annualRentPerSF = !isNil(monthlyRentPerSF) ? monthlyRentPerSF * 12 : undefined;

  return {
    address: propertyInformation.displayStreetAddress,
    bathrooms: leaseInformation.numberOfBathrooms,
    bedrooms: numberOfBedrooms,
    city: propertyInformation.displayCity,
    dateOfValue: leaseDate,
    position: coords && { lat: coords.latitude, lng: coords.longitude },
    monthlyRent,
    monthlyRentPerSF,
    annualRent,
    annualRentPerSF,
    squareFeet: leaseInformation.unitSquareFootage,
    state,
    unitType: leaseInformation.unitType,
    zip: postalCode,
    unitNumber,
    leaseId: id,
    leaseVersionNumber: version,
    isLatestVersion,
    status,
  };
};
